export const getEmailDetailsContainer = (content) => `
      <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F4F4F4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
        <div
        style="
          background: #f4f4f4;
          background-color: #f4f4f4;
          margin: 0px auto;
          margin-top: 8px;
          max-width: 600px;
        "
        >
        <table
          align="center"
          border="0"
          cellpadding="0"
          cellspacing="0"
          role="presentation"
          style="background: #f4f4f4; background-color: #f4f4f4; width: 100%"
        >
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid #e0e0e0;
                  direction: ltr;
                  font-size: 0px;
                  padding: 8px;
                  padding-left: 0;
                  padding-right: 0;
                  text-align: center;
                "
              >
                ${content}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
            <!--[if mso | IE]></td></tr></table><![endif]-->
`;
